import type { App as VueApp, Plugin } from "vue";
import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";
import InfoRequest from "@SoleDiCasa/Scripts/Components/InfoRequest/InfoRequest.vue";

const AppConfig: Plugin = {
    install(app: VueApp) {
        app.component("app-cookietoast", CookieToast);
        app.component("app-inforequest", InfoRequest);
    }
};

export default AppConfig;